import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutesRedirector } from 'src/components/RoutesRedirector';
import { ROUTES } from 'src/constants/routes';
import { AnalyticsTrackerProvider } from 'src/providers/analytics-tracker.provider';
import { PrefillApplicationProvider } from 'src/providers/prefil-application.provider';
import { RoutesRecorderProvider } from 'src/providers/routes-recorder.provider';
import { isProd } from '../../env/enviroment';

import Playground from '../../pages/_Playground/Playground';
import { routes } from '../../pages/routes';

export const PublicRoutes = () => {
  return (
    <AnalyticsTrackerProvider>
      <RoutesRecorderProvider>
        <PrefillApplicationProvider>
          <RoutesRedirector>
            <Routes>
              {!isProd && <Route path="/playground" element={<Playground/>}/>}

              {routes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={(
                    <React.Suspense fallback={<></>}>
                      <route.layout>
                        <route.component/>
                      </route.layout>
                    </React.Suspense>
                  )}
                />
              ))}

              <Route
                path="*"
                element={<Navigate to={ROUTES.START_APPLICATION_PATH}/>}
              />
            </Routes>
          </RoutesRedirector>
        </PrefillApplicationProvider>
      </RoutesRecorderProvider>
    </AnalyticsTrackerProvider>
  );
};
